(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _require = require('./webchat'),
    initButton = _require.initButton,
    initWindow = _require.initWindow;

var _require2 = require('./webchat/dialog'),
    openDialog = _require2.openDialog,
    closeDialog = _require2.closeDialog;

var dependencies = [{
  type: 'script',
  typeHtml: 'text/javascript',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/2.2.0/socket.io.js'
}];
/**
 * @function
 * @param  {{type: string, src: string, typeHtml: string}} data
 * @return {void}
 */

var initHeaderDependencies = function initHeaderDependencies(data) {
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement(data.type);

  if (data.type === 'script') {
    script.type = data.typeHtml;
    script.src = data.src;
  } else {
    script.type = 'text/css';
    script.href = data.src;
    script.rel = data.typeHtml;
  }

  head.appendChild(script);
};
/**
 * @function
 * @params {null}
 * @return {void}
 */


var eventListen = function eventListen() {
  var input = window.document.getElementById('chat_msg');
  input.addEventListener('keyup', function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      window.document.getElementById('enviarMsg').click();
    }
  });
};
/**
 * @function
 * @param  {string} url
 * @param  {string} serverID
 * @return {void}
 */


window.WebChat = function (url, serverID) {
  dependencies.map(initHeaderDependencies);
  setTimeout(function () {
    initButton("".concat(url, "/images/logo.png"), openDialog(url, serverID));
    initWindow(closeDialog);
    eventListen();
    window.document.getElementById('botao_chat').style.display = 'block';
  }, 4000);
};

},{"./webchat":7,"./webchat/dialog":6}],2:[function(require,module,exports){
"use strict";

/**
 * @function
 * @param  {any} data
 * @return {void}
 */
exports.persistenceLocalStorageSave = function (data) {
  return window.localStorage.setItem('webchat-session', JSON.stringify(data));
};
/**
 * @function
 * @params {null}
 * @return {Object}
 */


exports.persistenceLocalStorageGet = function () {
  return JSON.parse(window.localStorage.getItem('webchat-session'));
};

},{}],3:[function(require,module,exports){
"use strict";

var _require = require('../persistence'),
    persistenceLocalStorageSave = _require.persistenceLocalStorageSave,
    persistenceLocalStorageGet = _require.persistenceLocalStorageGet;
/**
 * @param  {any} socket
 * @param  {string} url
 * @param  {string} serverID
 */


exports.initSocket = function (socket, url, serverID) {
  var key = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  persistenceLocalStorageSave(key);
  var query = null;
  if (url.indexOf('http') >= 0) query = "ws://".concat(url.replace('http://', ''));
  if (url.indexOf('https') >= 0) query = "wss://".concat(url.replace('https://', ''));
  if (!socket) socket = window.io.connect(query, {
    transports: ['websocket'],
    upgrade: false,
    query: "name=".concat(key, "&serverID=").concat(serverID)
  });
  return socket;
};

},{"../persistence":2}],4:[function(require,module,exports){
"use strict";

var uuid = 0;
/**
 * @function
 * @param  {any} buttons
 * @return {void}
 */

var drawButton = function drawButton(buttons) {
  var button = document.createElement('button');
  button.textContent = buttons.displayValue;
  button.className = 'btn-small';
  button.style.margin = '10px';
  button.style.overflow = 'hidden';
  button.style.padding = '0';
  button.style.textTransform = 'none';
  button.style.borderRadius = '20px';
  if (buttons.backgroundColor) button.style.background = "#".concat(buttons.backgroundColor);
  if (buttons.fontColor) button.style.color = "#".concat(buttons.fontColor);
  if (buttons.width) button.style.width = "".concat(buttons.width, "px");
  button.setAttribute('data-front', buttons.nlpValue);
  button.setAttribute('data-backend', buttons.displayValue);
  button.setAttribute('onclick', "receiveClick('".concat(buttons.nlpValue, "', '").concat(buttons.displayValue, "')"));
  return button;
};
/**
 * @param  {any} socket
 * @return {{createButton: Function}}
 */


module.exports = function (socket) {
  /**
   * @param  {string} front
   * @param  {string} backend
   * @return {void}
   */
  window.receiveClick = function (front, backend) {
    window.sendMessageBack(backend, front, socket);
  };

  return {
    /**
    * @function
    * @param  {any} data
    * @param  {number} uid
    * @return {void}
    */
    createButton: function createButton(data) {
      var div = document.createElement('div');
      var nameDiv = "divButton-".concat(uuid++);
      div.id = nameDiv;
      div.style.cssText = 'width:100%;float:left;text-align:center;margin-bottom:20px;';
      window.document.getElementById('div_chat_messages').appendChild(div);

      for (var x = 0; x < data.items.length; x++) {
        var button = drawButton(data.items[x], socket);
        window.document.getElementById(nameDiv).appendChild(button);
      }
    }
  };
};

},{}],5:[function(require,module,exports){
"use strict";

var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
/**
 * @function
 * @param  {any} message
 * @return {any}
 */

var replaceMessageRegex = function replaceMessageRegex(message) {
  var msg = message.replace(new RegExp('\r?\n', 'g'), '<br>');
  return msg.replace(exp, "<a href='$1' target='_blank'>$1</a>");
};
/**
 * @function
 * @param  {any} data
 * @return {socketData: any, message: string}
 */


exports.typeMessage = function (data) {
  var message = replaceMessageRegex(data.message);
  if (message === '**oi**') return {
    socketData: null,
    message: message
  };
  if (data.origin && data.origin === 'client') return {
    socketData: null,
    message: message
  };
  return {
    socketData: data,
    message: message
  };
};

},{}],6:[function(require,module,exports){
"use strict";

var socket = null;

var _require = require('../socket'),
    initSocket = _require.initSocket;

var _require2 = require('./message'),
    welcomeMessage = _require2.welcomeMessage;

var _require3 = require('../persistence'),
    persistenceLocalStorageGet = _require3.persistenceLocalStorageGet;

var _require4 = require('../webchat/message'),
    sendMessageEvents = _require4.sendMessageEvents,
    receiveEventMessage = _require4.receiveEventMessage;

var initSocketComunicate = function initSocketComunicate(url, serverID) {
  socket = initSocket(socket, url, serverID);
  sendMessageEvents(socket);
  receiveEventMessage(socket);
  return socket;
};

var disconnectSocketCloseDialog = function disconnectSocketCloseDialog() {
  socket.close();
  socket = null;
};
/**
 * @function
 * @param  {any} socket
 * @return {void}
 */


exports.openDialog = function (url, serverID) {
  return function () {
    socket = initSocketComunicate(url, serverID);
    window.document.getElementById('chatbotDialog').style.display = 'block';
    var chatSession = persistenceLocalStorageGet();
    welcomeMessage(socket, chatSession);
    setTimeout(function () {
      window.document.getElementById('chat_msg').disabled = false;
      window.document.getElementById('enviarMsg').disabled = false;
      window.document.getElementById('chat_msg').addEventListener('click', function () {
        var chatMessages = document.getElementById('div_chat_messages');
        chatMessages.scrollTop = chatMessages.scrollHeight;
      });
    }, 4000);
    document.getElementById('chatbotDialog').focus();
  };
};
/**
 * @function
 * @param {null}
 * @return {void}
 */


exports.closeDialog = function () {
  disconnectSocketCloseDialog();
  window.document.getElementById('div_chat_messages').textContent = '';
  window.document.getElementById('chatbotDialog').style.display = 'none';
};

},{"../persistence":2,"../socket":3,"../webchat/message":8,"./message":8}],7:[function(require,module,exports){
"use strict";

/**
 * @function
 * @param  {string} image
 * @param  {function} openDialog
 * @return {void}
 */
var renderOpenDialog = function renderOpenDialog(image, openDialog) {
  var imageChat = window.document.createElement('img');
  imageChat.src = image;
  var chatBottom = window.document.createElement('div');
  chatBottom.className = 'botao_chat';
  chatBottom.id = 'botao_chat';
  chatBottom.style = 'display:none';
  chatBottom.onclick = openDialog;
  chatBottom.appendChild(imageChat);
  window.document.getElementsByTagName('body')[0].appendChild(chatBottom);
};
/**
 * @function
 * @params {null}
 * @return {void}
 */


var renderChatDialog = function renderChatDialog() {
  var cssStyle = window.screen.availHeight < 700 ? 'display:none; max-height: 500px;' : 'display:none';
  var chatPopup = window.document.createElement('div');
  chatPopup.id = 'chatbotDialog';
  chatPopup.className = 'chat-popup';
  chatPopup.style = cssStyle;
  window.document.getElementsByTagName('body')[0].appendChild(chatPopup);
};
/**
 * @function
 * @param  {string} image
 * @param  {function} openDialog
 * @return {void}
 */


exports.initButton = function (image, openDialog) {
  renderOpenDialog(image, openDialog);
  renderChatDialog();
};
/**
 * @function
 * @param  {function} closeDialog
 * @return {void}
 */


var renderChatTitleContainer = function renderChatTitleContainer(closeDialog) {
  var chatTituloContainer = window.document.createElement('div');
  chatTituloContainer.id = 'titulo';
  chatTituloContainer.className = 'chat_titulo_container';
  var tituloTexto = window.document.createElement('div');
  tituloTexto.id = 'titulo_texto';
  var contentTitle = window.document.createElement('h2');
  contentTitle.className = 'chat_titulo';
  contentTitle.textContent = '';
  tituloTexto.appendChild(contentTitle);
  var divFechaChat = window.document.createElement('div');
  divFechaChat.id = 'divFechaChat';
  divFechaChat.className = 'fecha_chat';
  divFechaChat.onclick = closeDialog;
  var materialIcons = window.document.createElement('i');
  materialIcons.className = 'material-icons';
  materialIcons.textContent = 'clear';
  divFechaChat.appendChild(materialIcons);
  chatTituloContainer.appendChild(tituloTexto);
  chatTituloContainer.appendChild(divFechaChat);
  window.document.getElementById('chatbotDialog').appendChild(chatTituloContainer);
};
/**
 * @function
 * @params {null}
 * @return {HtmlElement}
 */


var renderSendBoxChatBotContainer = function renderSendBoxChatBotContainer() {
  var sendBoxContainer = window.document.createElement('div');
  sendBoxContainer.className = 'send_box_chatbot_container';
  var buttonSend = window.document.createElement('button');
  buttonSend.id = 'enviarMsg';
  buttonSend.className = 'botao_enviar';
  var imgButton = window.document.createElement('img');
  imgButton.className = 'send';
  imgButton.src = 'https://chatbot.ypedia.com.br/images/send.png';
  buttonSend.appendChild(imgButton);
  sendBoxContainer.appendChild(buttonSend);
  return sendBoxContainer;
};
/**
 * @function
 * @params {null}
 * @return {void}
 */


var renderChatBodyContainer = function renderChatBodyContainer() {
  var chatBodyContainer = window.document.createElement('div');
  chatBodyContainer.className = 'chat-body-container';
  var divChatMessage = window.document.createElement('div');
  divChatMessage.id = 'div_chat_messages';
  divChatMessage.className = 'div_chat_messages';
  chatBodyContainer.appendChild(divChatMessage);
  window.document.getElementById('chatbotDialog').appendChild(chatBodyContainer);
};
/**
 * @function
 * @params {null}
 * @return {void}
 */


var renderChatFieldControl = function renderChatFieldControl() {
  var chatFieldControl = window.document.createElement('div');
  chatFieldControl.className = 'chat_field-control';
  var boxChatbotContainer = window.document.createElement('div');
  boxChatbotContainer.className = 'box_chatbot_container';
  var campoTexto = window.document.createElement('div');
  campoTexto.id = 'chat_msg';
  campoTexto.className = 'campo_texto';
  campoTexto.role = 'textbox';
  campoTexto.contentEditable = true;
  campoTexto.ariaMultiLine = true;
  campoTexto.arialLabel = 'Digite aqui.';
  campoTexto.spellcheck = false;
  var chatBotContainerSend = renderSendBoxChatBotContainer();
  boxChatbotContainer.appendChild(campoTexto);
  chatFieldControl.appendChild(boxChatbotContainer);
  chatFieldControl.appendChild(chatBotContainerSend);
  window.document.getElementById('chatbotDialog').appendChild(chatFieldControl);
};
/**
 * @function
 * @param  {Function} closeDialog
 * @return {void}
 */


exports.initWindow = function (closeDialog) {
  renderChatTitleContainer(closeDialog);
  renderChatBodyContainer();
  renderSendBoxChatBotContainer();
  renderChatFieldControl();
};

},{}],8:[function(require,module,exports){
"use strict";

var _require = require('../types/message'),
    typeMessage = _require.typeMessage;

var contractMessage = {
  origin: 'client',
  nome_usuario: 'Usuário',
  message: undefined,
  chatSession: undefined
};
/**
 * @function
 * @param  {string | Object} str
 * @return {boolean}
 */

var isJson = function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
}; // Send the message to the backend(nlp)

/**
 * @function
 * @param  {string} msnBack
 * @param  {string} msnFront
 * @param  {any} socket
 * @return {void}
 */


window.sendMessageBack = function (msnBack, msnFront, socket) {
  contractMessage.message = msnFront;
  contractMessage.origin = 'back';
  socket.emit('sendMessage', contractMessage);
  renderMessageFront(msnBack);
};

var RenderBalao = function RenderBalao(msg, currentTime, className) {
  var client = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var balaoCliente = window.document.createElement('div');
  balaoCliente.style.marginBottom = '10px';
  balaoCliente.className = className;
  if (client) balaoCliente.textContent = msg;else balaoCliente.innerHTML = msg;
  var chatTime = window.document.createElement('div');
  chatTime.className = 'chat_time';
  if (client) chatTime.textContent = currentTime;else chatTime.innerHTML = currentTime;
  balaoCliente.appendChild(chatTime);
  return balaoCliente;
};
/**
 * @function
 * @param  {string} msg
 * @return {void}
 */


var renderMessageFront = function renderMessageFront(msg) {
  var client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var currentTime = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  window.document.getElementById('div_chat_messages').appendChild(RenderBalao(msg, currentTime, 'message balao cliente', client));
  scroll();
};
/**
 * @function
 * @params {null}
 * @return {void}
 */


var scroll = function scroll() {
  var chatMessages = document.getElementById('div_chat_messages');
  chatMessages.scrollTop = chatMessages.scrollHeight;
};
/**
 * @function
 * @param  {any} socket
 * @return {void}
 */


exports.sendMessageEvents = function (socket) {
  var input = window.document.getElementById('enviarMsg');
  input.addEventListener('click', function (event) {
    event.preventDefault();
    var msg = window.document.getElementById('chat_msg').textContent;
    if (msg.length === 0) return;
    contractMessage.message = msg;
    renderMessageFront(msg, true);
    socket.emit('sendMessage', contractMessage);
    window.document.getElementById('chat_msg').textContent = '';
  });
};
/**
 * @function
 * @param {any} data
 * @return {void}
 */


var renderTitleChat = function renderTitleChat(data) {
  if (data.author) {
    var render = window.document.getElementsByClassName('chat_titulo');
    if (render) render.textContent = data.author;
  }
};

var renderTypingMessage = function renderTypingMessage() {
  var divChatTyping = window.document.createElement('div');
  divChatTyping.id = 'div_chat_typing';
  var imgChatTyping = window.document.createElement('img');
  imgChatTyping.className = 'chat_typing';
  imgChatTyping.src = 'https://demochatbot.blob.core.windows.net/demochatbot/images/typing.gif';
  imgChatTyping.alt = 'image22';
  divChatTyping.appendChild(imgChatTyping);
  return divChatTyping;
};

var renderImage = function renderImage(image) {
  var divChatImage = window.document.createElement('div');
  divChatImage.className = 'div_chat_image';
  var imageChatA = window.document.createElement('a');
  imageChatA.href = image;
  imageChatA.download = 'image.png';
  imageChatA.target = '_blank';
  var imageChat = window.document.createElement('img');
  imageChat.className = 'chat_image';
  imageChat.src = image;
  imageChat.alt = 'image';
  imageChat.target = '_blank';
  imageChatA.appendChild(imageChat);
  divChatImage.appendChild(imageChatA);
  return divChatImage;
};
/**
 * @function
 * @param {any} socket
 * @param  {any} data
 * @return {void}
 */


var renderMessage = function renderMessage(socket) {
  return function (data) {
    var _require2 = require('../types/button')(socket),
        createButton = _require2.createButton;

    var currentTime = new Date().toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
    var typingElement = window.document.getElementsByClassName('chat_typing');
    if (typingElement.length > 0) typingElement[0].remove();

    if (data.type === 'typing' || data.image === 'typing') {
      window.document.getElementById('div_chat_messages').appendChild(renderTypingMessage());
      scroll();
      return null;
    }

    if (data.type === 'image') {
      window.document.getElementById('div_chat_messages').appendChild(renderImage(data.image));
      setTimeout(scroll, 1000);
      return null;
    }

    var _typeMessage = typeMessage(data),
        socketData = _typeMessage.socketData,
        message = _typeMessage.message;

    if (!socketData || !socketData.message) return null;
    renderTitleChat(data);

    if (socketData.origin === 'client') {
      window.document.getElementById('div_chat_messages').appendChild(RenderBalao(message, currentTime, 'message balao cliente'));
      scroll();
      return null;
    }

    if (socketData.origin === 'bot') {
      if (isJson(socketData.message)) {
        var objectData = JSON.parse(socketData.message);

        switch (objectData.type) {
          case 'button':
            createButton(objectData);
            scroll();
            return null;

          case 'carousel':
            break;

          default:
            break;
        }
      }

      window.document.getElementById('div_chat_messages').appendChild(RenderBalao(message, currentTime, 'message balao atendente'));
      scroll();
    }
  };
};
/**
 * @param  {any} socket
 * @return {void}
 */


exports.receiveEventMessage = function (socket) {
  socket.on('receivedMessage', renderMessage(socket));
};
/**
 * @param  {any} socket
 * @param  {string} chatSession
 * @return {void}
 */


exports.welcomeMessage = function (socket, chatSession) {
  if (!socket) return null;
  window.document.getElementById('div_chat_messages').appendChild(renderTypingMessage());
  contractMessage.message = '**oi**';
  contractMessage.chatSession = chatSession;
  socket.emit('sendMessage', contractMessage);
};

},{"../types/button":4,"../types/message":5}]},{},[1]);
